OT.createNS('OT.Common');

OT.Common.getWindow = function () {
    return window;
};

OT.Common.getNavigator = function () {
    return navigator;
};

OT.Common.DeviceType = {
    phone: "phone",
    tablet: "tablet",
    large: "large",
    xLarge: "xLarge",
    xXLarge: "xXLarge"
};